/*=========================================================================================
  File Name: moduleUserState.js
  Description: User Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Useror: SpeedCodeLabs
  Useror URL: http://www.speedcodelabs.com
==========================================================================================*/

export default { 
  user:null,
  policies:[]
}